import { VARIANT_DEFAULT, VARIANT_ERROR, VARIANT_SUCCESS } from './const.js';

const variants = [ VARIANT_DEFAULT, VARIANT_ERROR, VARIANT_SUCCESS ];

export default {
  props: {
    items: {
      type: [Array, Object, String],
      required: true,
    },
    variant: {
      type: String,
      default: VARIANT_DEFAULT,
      validator: variant => variants.includes(variant),
    }
  },

  computed: {
    classes() {
      return [`markup-popup-form-notifications_${this.variant}`];
    },
    list() {
      const { items } = this;
      const list = Array.isArray(items) ? items : [ items ];
      return list.map(content => {
        const base = typeof content === 'object' ? content : { content };
        return {
          ...base,
          classes: {
            'markup-popup-form-notifications__item_strong': !!base.strong
          }
        };
      })
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/markup/popup/form/notification/component.js